import BtnOptions from './BtnOptions';
import UserSelectStates from '../../../../components/form/Selects/UserSelectStates';

const Report8Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <UserSelectStates
            onHandleChange={(opt) => {
              handleOnSetFieldValue('r8states', opt);
            }}
            value={values?.r8states}
            getPermissionsFrom="client"
            hasSelectOptions
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={!values.r8states || values.r8states.length === 0}
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report8Options;
